import { TypedUseSelectorHook, useSelector } from "react-redux";
import type { RootState } from "../store/rootStore";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;